var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static-wrap"},[_c('Header',{on:{"openFreeTrial":_vm.openFreeTrial}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('Footer')],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48f6d0ff","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FrontPageTmpl.vue
// module id = null
// module chunks = 